// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-aVNLD";
var _3 = "timelimit-jakl6";
export { _1 as "__esModule", _2 as "container", _3 as "timelimit" }
export default { "__esModule": _1, "container": _2, "timelimit": _3 }
